module.exports = __webpack_public_path__ + "static/media/springville_club_house_bg.0a754023.webp";